import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InversionistasService } from '../../../services/inversionistas.service';
import { HelpersService } from '../../../services/tools/helpers.service';

declare var $: any;

@Component({
  selector: 'app-calendario-pagos',
  templateUrl: './calendario-pagos.component.html',
  styleUrls: ['./calendario-pagos.component.scss']
})
export class CalendarioPagosComponent implements OnInit {
  public calendarioPagosOriginal: any[] = [];
  public calendarioPagos: any[] = [];
  public loading: boolean = true;
  public rangoMesTexto: string = '';
  public fechaActual: Date = new Date();
  public itemSeleccionado: any = null;
  public filtroActual: string = 'todos';
  
  public kpis: any = {
    total_pendientes: 0,
    cantidad_pendientes: 0,
    total_aplicados: 0,
    total_reinversiones: 0
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private inversionistasService: InversionistasService,
    private helperService: HelpersService
  ) { }

  ngOnInit() {
    this.actualizarTextoRango();
    this.getCalendarioPagos();
  }

  public getCalendarioPagos() {
    this.loading = true;
    const mes = this.fechaActual.getMonth() + 1;
    const anio = this.fechaActual.getFullYear();

    this.inversionistasService.obtenerCalendarioPagos(mes, anio).subscribe(
      (response: any) => {
        const result = response.json ? response.json() : response;
        if (result && result.success && result.content) {
          this.calendarioPagosOriginal = result.content.pagos || [];
          this.aplicarFiltroActual();
          
          if (result.content.kpis) {
            this.kpis = result.content.kpis;
          }
        }
        this.loading = false;
      },
      error => {
        this.loading = false;
        this.helperService.httpGlobalError(error);
      }
    );
  }

  public filtrarPorEstatus(estatus: string) {
    this.filtroActual = estatus;
    this.aplicarFiltroActual();
  }

  // Validación segura sin usar el operador "?." para evitar errores de compilación
  private aplicarFiltroActual() {
    if (this.filtroActual === 'todos') {
      this.calendarioPagos = [...this.calendarioPagosOriginal];
    } else {
      this.calendarioPagos = this.calendarioPagosOriginal.filter(
        item => item.estatus && item.estatus.toLowerCase() === this.filtroActual.toLowerCase()
      );
    }
  }

  public mesAnterior() {
    this.fechaActual.setMonth(this.fechaActual.getMonth() - 1);
    this.filtroActual = 'todos';
    this.actualizarTextoRango();
    this.getCalendarioPagos();
  }

  public mesSiguiente() {
    this.fechaActual.setMonth(this.fechaActual.getMonth() + 1);
    this.filtroActual = 'todos';
    this.actualizarTextoRango();
    this.getCalendarioPagos();
  }

  private actualizarTextoRango() {
    const meses = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];
    const nombreMes = meses[this.fechaActual.getMonth()];
    const anio = this.fechaActual.getFullYear();
    this.rangoMesTexto = nombreMes + ' ' + anio;
  }

  public pagar(item: any) {
    this.itemSeleccionado = item;
    $('#modalPago').modal('show');
  }

  public ejecutarPago() {
    if (!this.itemSeleccionado) return;

    this.loading = true;
    $('#modalPago').modal('hide');

    this.inversionistasService.procesarPagoCalendario(this.itemSeleccionado).subscribe(
      (response: any) => {
        const result = response.json ? response.json() : response;
        if (result && result.success) {
          alert('Pago aplicado correctamente');
          this.getCalendarioPagos();
        } else {
          this.loading = false;
          const msg = (result && result.message) ? result.message : 'No se pudo procesar el pago';
          alert(msg);
        }
      },
      error => {
        this.loading = false;
        this.helperService.httpGlobalError(error);
      }
    );
  }

  public reinvertir(item: any) {
    if (!confirm('¿Estás seguro de procesar la reinversión para ' + item.destinatario + '?')) {
      return;
    }

    this.loading = true;
    this.inversionistasService.procesarReinversionCalendario(item).subscribe(
      (response: any) => {
        const result = response.json ? response.json() : response;
        if (result && result.success) {
          alert('Reinversión aplicada correctamente');
          this.getCalendarioPagos();
        } else {
          this.loading = false;
          const msg = (result && result.message) ? result.message : 'No se pudo procesar la reinversión';
          alert(msg);
        }
      },
      error => {
        this.loading = false;
        this.helperService.httpGlobalError(error);
      }
    );
  }

  public volver() {
    window.history.back();
  }
}


// WEBPACK FOOTER //
// ./src/app/inversiones/pagares/calendario/calendario-pagos.component.ts